import { useRef, useState } from "react";
import { UploadCloud, Loader2, FileText, X, CheckCircle2 } from "lucide-react";
import { uploadFile } from "@/lib/api";
import { toast } from "sonner";

export function FileUpload({ label, hint, accept = "image/*,application/pdf", visibility = "public", category = "photo", multiple = false, value = [], onChange, testid }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const handle = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setBusy(true);
    try {
      const results = [];
      for (const f of files) {
        const data = await uploadFile(f, { visibility, category });
        results.push(data);
      }
      onChange(multiple ? [...value, ...results] : results.slice(0, 1));
      toast.success("Arquivo enviado!");
    } catch (err) {
      toast.error("Falha no envio do arquivo.");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = (idx) => onChange(value.filter((_, i) => i !== idx));

  return (
    <div>
      {label && <label className="text-sm font-medium text-[#1c1917]">{label}</label>}
      <div
        data-testid={testid}
        onClick={() => !busy && inputRef.current?.click()}
        className="mt-1.5 border-2 border-dashed border-[#e7e5e4] rounded-2xl p-6 flex flex-col items-center justify-center bg-[#fafaf8] hover:bg-[#e8f0ec]/50 hover:border-[#1b5e3f] cursor-pointer transition-all text-center"
      >
        {busy ? <Loader2 className="w-6 h-6 animate-spin text-[#1b5e3f]" /> : <UploadCloud className="w-6 h-6 text-[#1b5e3f]" />}
        <p className="text-sm text-[#1c1917] font-medium mt-2">{busy ? "Enviando..." : "Clique para enviar"}</p>
        <p className="text-xs text-[#78716c] mt-0.5">{hint || "Foto ou PDF"}</p>
      </div>
      <input ref={inputRef} type="file" accept={accept} multiple={multiple} onChange={handle} className="hidden" />

      {value.length > 0 && (
        <div className="mt-3 space-y-2">
          {value.map((f, i) => (
            <div key={i} className="flex items-center justify-between bg-white border border-[#e7e5e4] rounded-xl px-3 py-2">
              <div className="flex items-center gap-2 min-w-0">
                {f.category === "photo" || /\.(png|jpe?g|webp|gif)$/i.test(f.filename || "") ? (
                  <img src={f.url} alt="" className="w-9 h-9 rounded-lg object-cover" />
                ) : (
                  <FileText className="w-5 h-5 text-[#1b5e3f]" />
                )}
                <span className="text-sm text-[#1c1917] truncate">{f.filename || "arquivo"}</span>
                <CheckCircle2 className="w-4 h-4 text-[#10b981] shrink-0" />
              </div>
              <button type="button" onClick={() => remove(i)} className="text-[#78716c] hover:text-[#ef4444]"><X className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
